export var TabStyle;
(function (TabStyle) {
    TabStyle["TEXT"] = "text";
    TabStyle["IMG"] = "image";
})(TabStyle || (TabStyle = {}));
export var FixedPosition;
(function (FixedPosition) {
    FixedPosition["STICKY"] = "sticky";
    FixedPosition["NONE"] = "none";
})(FixedPosition || (FixedPosition = {}));
export var ExtraIconType;
(function (ExtraIconType) {
    ExtraIconType["HORIZONTAL"] = "horizontal";
    //横滑
    ExtraIconType["VERTICAL"] = "vertical";
    //下拉
})(ExtraIconType || (ExtraIconType = {}));
